/* eslint-env browser */
import { Component, Input, OnInit,  OnDestroy, ChangeDetectorRef, ComponentRef, ViewContainerRef, AfterViewInit, PLATFORM_ID, Inject, input, output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Customer } from '@app/models/customers/Customer';
import { CommonOffer } from '@app/models/offers/CommonOffer';
import { VerifyResponse } from '@app/models/offers/VerifyResponse';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { formatNumber, isPlatformBrowser } from '@angular/common';
import { NavigationExtras, Router } from '@angular/router';
import { EncryptionService } from '@app/services/encyption.service';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { FlugDetailComponent } from '@app/components/modals/flugdetail/flugdetail.component';
import moment from 'moment';
import { FlugDetailMComponent } from '../offerpackdetailmodal/flug-detail/flug-detail.component';
import { MapService } from '@app/services/map.service';
import { TrafficsService } from '@app/services/traffics.service';

@Component({
    selector: 'app-offerpackflightcard',
    templateUrl: './offerpackflightcard.component.html',
    styleUrls: ['./offerpackflightcard.component.scss'],
    standalone: false
})
export class OfferpackflightcardComponent implements OnInit, OnDestroy, AfterViewInit {
    private unsubscribe$ = new Subject();
    readonly index = input<number>(undefined);
    readonly mode = input<string>(undefined);
    readonly reference = input<string>(undefined);
    readonly offerid = input<string>(undefined);
    @Input() offer: CommonOffer;
    readonly currentCustomer = input<Customer>(undefined);
    @Input() booking: VerifyResponse;
    readonly desktopTemplate = input<string>(undefined);
    readonly title = input<string>(undefined);
    readonly gpsData = input([]);
    readonly removeFromList = output<string>();
    showAlternative: boolean = false;
    checkloading: boolean = true;
    readonly changeindex = output<{
        dragedindex: number;
        dropindex: number;
    }>();

    travelerText: string = '';
    partnerid: string = '';
    prcdetail: string = '';

    component: ComponentRef<any>;
    sendRegSub: Subscription;
    sendBook: Subscription;
    showDetail: boolean = false;
    isBrowser: boolean = false;
    map = null;
    readonly openSetComment = output<boolean>();
    constructor(
        protected dialog: MatDialog,
        protected trafficsService: TrafficsService,
        protected encservice: EncryptionService,
        protected router: Router,
        protected cdr: ChangeDetectorRef,
        protected guardService: AuthGuardService,
        protected viewContainerRef: ViewContainerRef,
        protected mapService: MapService,
        @Inject(PLATFORM_ID) private platformId: any
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        this.initPartner();
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();

        this.sendRegSub?.unsubscribe();
        this.sendBook?.unsubscribe();
    }

    async initPartner() {
        this.guardService.getPartner$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(partner => {
            this.partnerid = partner?.partnerid
            if (this.partnerid?.length > 0) {
                this.initData();
                this.checkOffer();
            }
        });
    }

    async checkOffer() {
        if (this.booking.commonOffer?.code?.length > 0) {
            this.checkloading = true;
            let childtrenages = '';
            let adults = 0;
            for (let i = 0; i < this.booking.travellerList?.length; i++) {
                if (this.booking.travellerList[i].type === 'K' || this.booking.travellerList[i].type === 'B') {
                    if (childtrenages?.length > 0) {
                        childtrenages += ',' + this.booking.travellerList[i].age;
                    } else {
                        childtrenages += this.booking.travellerList[i].age;
                    }
                } else {
                    adults++;
                }
            }

            const target = {
                data: {
                    code: this.booking.commonOffer.code,
                    adults: adults,
                    children: childtrenages,
                    rooms: '', // 3 rooms must be like : [{adults:2},{adults:1},{children:2}]
                    type: 'full',
                    optionAlternativeFlightOfferList: false,
                },
                mode: this.booking.mode,
                extra: this.booking.extra,
                insertOffer: true
            };

            this.trafficsService.request(target, 'offers/code').pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe((res) => {
                this.checkloading = false;
                const tmp_reference = this.booking.reference;
                if (!res.error) {
                    if (res.statusCode === 'OK' || res.statusCode === 'RQ') {
                        this.booking = res;
                        this.booking.reference = tmp_reference;
                    } else {
                        this.showAlternative = true;
                    }
                }
                this.initData();
                this.cdr.detectChanges();
            });
        }
    }

    async setCommentModal() {
        this.openSetComment.emit(true);
    }

    async dragStart(ev: DragEvent, index: number) {
        ev.stopPropagation();
        ev.dataTransfer.effectAllowed = 'move';
        ev.dataTransfer.setData('dragedindex', index + '');
    };

    async dragOver(event: DragEvent) {
        event.preventDefault();
    }

    async dropp(ev: DragEvent) {
        ev.stopPropagation();
        const dragedindex = ev.dataTransfer.getData('dragedindex')
        const index = this.index();
        if (Number(dragedindex) > 0 && Number(dragedindex) !== index) {
            this.changeindex.emit({ dragedindex: Number(dragedindex) - 1, dropindex: index - 1 });
        }
    }

    async initData() {
        let countEr = 1;
        let kind = 0;
        let erw = 0;
        for (let i = 0; i < this.booking?.travellerList?.length; i++) {
            let prc = ''
            if (this.booking.travellerList[i].price?.value?.length > 0) {
                prc = formatNumber(Number(this.booking.travellerList[i].price?.value), 'de-DE', '1.2-2');
            } else {
                if (this.booking.travellerList[i].type === 'H') {
                    prc = formatNumber(Number(this.booking.pricePerPerson?.value), 'de-DE', '1.2-2');
                } else {
                    prc = '?';
                }
            }
            if (prc?.length > 0) {
                if (this. booking.travellerList[i].type === 'H') {
                    this.prcdetail += countEr + '.Erwachsener ' + prc + ' EUR\n';
                    countEr++;
                    erw += 1;
                } else {
                    this.prcdetail += countEr + '.Kinder ' + prc + ' EUR\n';
                    countEr++;
                    kind += 1;
                }
            }
        }
        if (erw > 0) {
            this.travelerText = erw + ' Erwachsene';
        }
        if (kind > 0) {
            this.travelerText += ', ' + kind + ' Kinder';
        }
        this.cdr.detectChanges();
    }

    async removeFromListF() {
        this.removeFromList.emit(this.offerid());
    }

    async goToBooking() {
        if (this.booking?.offerid?.length > 0) {
            const realparams = {
                offerid: this.booking?.offerid,
                productType: this.booking?.mode,
                reference: this.reference()?.length > 0 ? this.reference() : 'offerpack'
            };
            const navigationExtras: NavigationExtras = {
                queryParams: { params: this.encservice.encrypt(realparams) }
            };
            const url = this.router.createUrlTree(['booking'], navigationExtras).toString();
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('visibility', 'hidden');
            link.click();
        }
    }

    ngAfterViewInit(): void {
        if (this.isBrowser) {
            setTimeout(() => {
                this.onMapReady();
            }, 500);
        }
    }

    async onMapReady() {
        if (isPlatformBrowser(this.platformId)) {
            this.map = this.mapService.Leaflet.map('map' + this.index());
            this.mapService.Leaflet.tileLayer('https://{s}.tile.openstreetmap.de/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' }).addTo(this.map);
            this.map?.invalidateSize();
            this.initMap();
        }
    }

    async initMap() {
        const fitBounds = [];
        const latlngs = [];
        const layers = new this.mapService.Leaflet.FeatureGroup();
        for (let i = 0; i < this.gpsData().length; i++) {
            const gpsData = this.gpsData();
            latlngs.push([gpsData[i].from.latitude, gpsData[i].from.longitude],
                [gpsData[i].to.latitude, gpsData[i].to.longitude]);
            if (gpsData[i].to.latitude && gpsData[i].from.longitude) {
                fitBounds.push([gpsData[i].from.latitude, gpsData[i].from.longitude],
                    [gpsData[i].to.latitude, gpsData[i].to.longitude]);
                layers.addLayer(this.mapService.Leaflet.marker([gpsData[i].from.latitude, gpsData[i].from.longitude],
                    {
                        icon: this.mapService.Leaflet.icon({
                            iconSize: [25, 41],
                            iconAnchor: [13, 41],
                            iconUrl: 'leaflet/marker-icon.png',
                            shadowUrl: 'leaflet/marker-shadow.png'
                        })
                    }
                ).bindPopup(gpsData[i].from.name));
                layers.addLayer(this.mapService.Leaflet.marker([gpsData[i].to.latitude, gpsData[i].to.longitude],
                    {
                        icon: this.mapService.Leaflet.icon({
                            iconSize: [25, 41],
                            iconAnchor: [13, 41],
                            iconUrl: 'leaflet/marker-icon.png',
                            shadowUrl: 'leaflet/marker-shadow.png'
                        })
                    }
                ).bindPopup(gpsData[i].to.name));
            }
        }
        this.mapService.Leaflet.polyline(latlngs, { color: '#545454' }).addTo(this.map);
        this.map.addLayer(layers);
        this.map.fitBounds(fitBounds);
        this.map?.invalidateSize();
    }

    async gotoOffers() {
        if (this.booking?.offerid?.length > 0) {
            let adults = 0;
            const children = [];
            let childrencount = 0;
            for (let i = 0; i < this.booking?.travellerList.length; i++) {
                if (this.booking?.travellerList[i].type === 'H') {
                    adults++;
                } else if (this.booking?.travellerList[i].type === 'K') {
                    childrencount++;
                    children.push({
                        age: this.booking?.travellerList[i].age,
                        children: childrencount
                    });
                }
            }
            const realparams = {
                reisedauerResult: {
                    name: this.booking?.commonOffer?.flightOffer?.travelDate?.duration?.length > 0 ? this.booking?.commonOffer?.flightOffer?.travelDate?.duration + ' Tage' : 'Beliebig',
                    minDuration: this.booking?.commonOffer?.hotelOffer?.travelDate?.duration?.length > 0 ? this.booking?.commonOffer?.hotelOffer?.travelDate?.duration : '1',
                    maxDuration: this.booking?.commonOffer?.hotelOffer?.travelDate?.duration?.length > 0 ? this.booking?.commonOffer?.hotelOffer?.travelDate?.duration : '30'
                },
                reisezeitraumResult: {
                    start: moment(this.booking?.commonOffer?.flightOffer?.travelDate?.fromDate).format('YYYY-MM-DD'),
                    end: moment(this.booking?.commonOffer?.flightOffer?.travelDate?.toDate).format('YYYY-MM-DD'),
                    minDuration: this.booking?.commonOffer?.hotelOffer?.travelDate?.duration?.length > 0 ? this.booking?.commonOffer?.hotelOffer?.travelDate?.duration : '1',
                    maxDuration: this.booking?.commonOffer?.hotelOffer?.travelDate?.duration?.length > 0 ? this.booking?.commonOffer?.hotelOffer?.travelDate?.duration : '30'
                },
                productType: this.booking.mode,
                reisendeResult: {
                    children: children,
                    adults: adults,
                },
                airportsResult: [this.offer?.flightOffer?.flight?.departureAirport],
                arrivalAirportList: [this.offer?.flightOffer?.flight?.arrivalAirport],
            };
            if (this.mode() === 'oneway') {
                delete realparams.reisedauerResult;
            }
            const navigationExtras: NavigationExtras = {
                queryParams: { params: this.encservice.encrypt(realparams) }
            };
            const url = this.router.createUrlTree(['flugs'], navigationExtras).toString();
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('visibility', 'hidden');
            link.click();
        }
    }

    async openFluginfo() {
        const target = { data: { offer: this.offer }, autoFocus: false };
        this.dialog.open(FlugDetailComponent, target);
    }

    async openDetail() {
        if (this.component) {
            this.component.destroy();
        }
        this.sendRegSub?.unsubscribe();
        this.component = this.viewContainerRef.createComponent(FlugDetailMComponent);
        this.component.instance.booking = this.booking;
        this.sendRegSub = this.component.instance.sendAlt.subscribe((ev) => {
            if (ev) {
                this.gotoOffers();
            }
        });
        this.sendBook = this.component.instance.sendBook.subscribe((ev) => {
            if (ev) {
                this.goToBooking();
            }
        });
        this.showDetail = true;
        this.cdr.detectChanges();
    }

    closeModal(ev) {
        if (ev) {
            this.showDetail = false;
            this.cdr.detectChanges();
        }
    }
}
